// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.multiplex.RentalManagerUserPropertyMultiplexWebApiHandler

import { frontEndRequestV2 } from '@zg-rentals/ts-client-fetch';
import type { RentalManagerEnvironment } from '@zg-rentals/rental-manager-env-base';

import type {
  UserPropertyMultiplexCreateUnitsRequestWebDto,
  UserPropertyMultiplexCreateUnitsResponseWebDto,
  UserPropertyMultiplexGetUnitNumbersResponseWebDto,
} from '../..';

interface GetUnitNumbersParams {
  fullAddress: string;
}

export const RentalManagerUserPropertyMultiplexWebApiHandler_create_Path =
  '/api/web/v1/users/properties/multiplex/create';

/**
 * Create units for a multiplex
 */
export const RentalManagerUserPropertyMultiplexWebApiHandler_create = (
  postData: UserPropertyMultiplexCreateUnitsRequestWebDto,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<
    never,
    UserPropertyMultiplexCreateUnitsRequestWebDto,
    UserPropertyMultiplexCreateUnitsResponseWebDto
  >({
    endpoint: RentalManagerUserPropertyMultiplexWebApiHandler_create_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    postData: postData,
    environment,
  });
};

export const RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers_Path =
  '/api/web/v1/users/properties/multiplex/getUnitNumbers';

/**
 * Get unit numbers for a multiplex
 */
export const RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers = (
  getParams: GetUnitNumbersParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<GetUnitNumbersParams, never, UserPropertyMultiplexGetUnitNumbersResponseWebDto>({
    getParams: getParams,
    endpoint: RentalManagerUserPropertyMultiplexWebApiHandler_getUnitNumbers_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};
